let uploadedPrints = [];
let uploadedPrints2 = [];
let uploadedPrints3 = [];
let post_list = '';
let post_list2 = '';
var picker;
var prints_size;
var prints_width;
var prints_height;
var prints_title;
var prints_paper;
var prints_frame;
var prints_width_px;       
var prints_height_px;   
var prints_ratio;   

let inchToPx = 300;
let cmToPx = 118;

$(document).ready(function() {   
	$(".btn-add-to-cart").attr("disabled");
 //   getArtPrintsSize();
  
    $("body").on('click', "button.close", function(e){
		closeUploader();    
    });  
    $("body").on('click', "button.btn-del", function(e){
		  $(this).parent().parent().remove();
      $(".mango-uploader-prints-qty").html( countPrints() );
      $(".mango-uploader-prints-sum").html( calculatePrintsPrice( variants, pricelist, countPrints() ) );         

      uploadedPrints3 = [];
      $('.photo').each(function () {
          let src = $(this).find('.photo-img img').attr('src');
          if (src) {
              let hash = src.substring(src.lastIndexOf('/') + 1);
              uploadedPrints3 += hash + ';';
          }
      });
      uploadedPrints3 = uploadedPrints3.replace(/;$/, '');
      console.log(uploadedPrints3);      

      let hashSet = new Set(uploadedPrints3.split(';'));
      // Filtrowanie tablicy – zostają tylko te elementy, których hash znajduje się w hashSet
      uploadedPrints2 = uploadedPrints2.filter(item => {
          let hash = item.split('^')[1];
          return hashSet.has(hash);
      });
      console.log(uploadedPrints2); 
    });    

  /*
    $(".properties_rozmiar").on('change', function(e){
      getArtPrintsSize(); 
    });  
*/


    $("#form-add-to-cart").submit(function (e) {
        e.preventDefault();
        $("#btn-add-to-cart").attr("disabled", true);

//        $.each( uploadedPrints3, function( key, value ) {
//            post_list = post_list + value +',';
//        });

        $.each( uploadedPrints2, function( key, value ) {
            var temp_array = value.split('^');
            post_list = post_list + temp_array[1] +',';
            post_list2 = post_list2 + temp_array[0] +',';          
        });

        let properties = {
        	'Nazwa projektu': prints_title,
            'Papier': prints_paper,          
            'Ramka': prints_frame,    
            '_printsSize': prints_size,   
            '_printsUploadedFiles': post_list,  
            '_printsUploadedFilesNames': post_list2,               
        };

        let formData = {
         'items': [{
          'id': getVariantId(variants, countPrints()),
          'quantity': countPrints(),
          'properties': properties,
          }]
        };
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
        window.location = '/cart';                
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });   
    });
  
  
    $("#print-upload-show-btn").click(function(){

        if( $(".properties_nazwa_projektu").val().length === 0 ) { 
          alert("Zanim przejdziesz do wyboru zdjęć, UZUPEŁNIJ NAZWĘ"); 
          return false; 
        } 
        if( $(".properties_papier").length && $(".properties_papier").val().length === 0 ) { 
          alert("WYBIERZ RODZAJ PAPIERU"); 
          return false; 
        } 
      
        $("body").css("overflow", "hidden");      
		
        prints_size = $("#mango_print_file_size").val();
        prints_title = $(".properties_nazwa_projektu").val();
        prints_paper = $(".properties_papier").val();
        prints_frame = $(".properties_ramka").val();

        if( parseInt($("#mango_print_file_width").val()) > parseInt($("#mango_print_file_height").val()) ) {
          prints_width = parseInt($("#mango_print_file_width").val());
          prints_height = parseInt($("#mango_print_file_height").val());
        } else {
          prints_height = parseInt($("#mango_print_file_width").val());
          prints_width = parseInt($("#mango_print_file_height").val());         
        }
        prints_width_px = prints_width * cmToPx;       
        prints_height_px = prints_height * cmToPx;   
        prints_ratio = prints_height/prints_width;    
      
        $(".mango-uploader-prints-nazwa").html(prints_title);
        $(".mango-uploader-prints-size").html(prints_size);
        $(".mango-uploader-title-prints-size").html(prints_size);      
        $(".mango-uploader-prints-paper").html(prints_paper);
        $(".mango-uploader-prints-frame").html(prints_frame);      
        $(".mango-uploader-prints-resolution").html( prints_width_px +'x'+prints_height_px);   

		const filestack_client = filestack.init('AbkDGv2FYSHi0mxqhYMgQz'); 
        const options = {
        	displayMode: 'inline',
        	container: '#droppaneprints',    
  			accept: ["image/jpeg", "image/jpg"],          
			fromSources: ["local_file_system","dropbox","googledrive","onedrive"],
			exposeOriginalFile: true,      
          	maxFiles: 1000,
          	minFiles: 1,          
            transformations: {
            	crop: false,
           		circle: false,
           	 	rotate: false
            },          
            onFileUploadFinished: function(file) {
				//console.log(file);              
				uploadedPrints.push(file["url"]);
    			uploadedPrints2.push(file["filename"] +'^'+file["handle"]);      
    			uploadedPrints3.push(file["handle"]);
				console.log(uploadedPrints2);  
              
                $.ajax({
					type: "POST",
					url: "https://filestack.qtalbums.ovh/token_to_db.php",
					headers: { 'Content-Type': 'application/x-www-form-urlencoded'},                  
					data: { hash : $( "#mango_post_list_data_hash" ).val(), files : file["filename"] +'^'+file["handle"], source : 'snapalbums' },
					success: function(msg){ console.log(msg);}
				});   
            },   
    

       	 	onUploadDone: function(){
//              	uploadedPrints2.sort();
     			uploadFinished(uploadedPrints2);
            	picker.close();                    
 //               uploadedFiles.release();
  			},     
//          	onFileSelected: checkImgSize,  
          	onClose: function(){
		//		picker.cancel();              
        //      alert('koniec');
            },        
        };
      	picker = filestack_client.picker(options);

   
		$(".mango-printuploader-wrapper").show();
		$("#mango-printuploader-modal").show();
      	$("#mango-printuploader-step-1").show();           
		picker.open();  
    });
  
  function calculatePrintsPrice( variants, pricelist, quantity) {
    $.each(variants, function (i, item) {
      var variant_split = item.split('-');
      if( (quantity >=  parseInt(variant_split[0]) ) && (quantity < ( parseInt(variant_split[1]) + 1)) ) { variant = i;}
    });
//        console.log( pricelist[variant] * quantity ); 
    return ((pricelist[variant] * quantity)/100).toFixed(2);
    
  }
  

  

    function getArtPrintsSize(){
      var prints_size = $(".properties_rozmiar").val();
      var prints_height = 0;
      var prints_width = 0;
      
      prints_size = prints_size.replace("cm", "");
      prints_height = prints_size.split("x")[0];      
      prints_width = prints_size.split("x")[1];      
//console.log('wybrany rozmiar:' + prints_size + '- '+prints_height+'=x='+ prints_width);
      $("#mango_print_file_size").val(prints_size);
      $("#mango_print_file_height").val(prints_height);      
      $("#mango_print_file_width").val(prints_width);      
    }  
  
    function countPrints(){
      var prints_qty = 0;
 //     prints_qty = $("div.photo").length;
 //     prints_qty = $("#mango-printuploader-printslis input:hidden").length;


      prints_qty = $("#mango-printuploader-printslist").find("input").length;
      //$(".photo img" ).each( prints_qty = prints_qty+1 );
      //console.log('prints qty = ' + prints_qty);
      return prints_qty;
      
    }  
    function getVariantId(variants, quantity){
      $.each(variants, function (i, item) {
        var variant_split = item.split('-');
        if( (quantity >=  parseInt(variant_split[0]) ) && (quantity < ( parseInt(variant_split[1]) + 1)) ) {
          variant = i;
        }
      });
      return variant;
    }  

    function closeUploader(){ 
        if(confirm("Opuszczając to okno, lista dodanych zdjęć nie zostanie zachowana. Będzie trzeba uploadować je ponownie. Jesteś pewien że chcesz wyjść?")){
  //		  console.log(uploadedFiles);
    		$(".mango-printuploader-wrapper").hide();
    		$("#mango-printuploader-modal").hide();
    		$("#mango-printuploader-step-1").hide();            
        	$("#mango-printuploader-step-2").hide();     
    		$("#mango-printuploader-step-3").hide();       
            $("#mango-printuploader-files").val('');
            $("#mango-printuploader-printslist *").remove();
            $("body").css("overflow", "auto");    

        	picker.close();      
            uploadedPrints = [];
            uploadedPrints2 = [];    
  //		  console.log(uploadedFiles);   
        }
        else{
            return false;
        }       
    }

    function finishUploader(){
		$(".mango-uploader-wrapper").hide();
		$("#mango-uploader-modal").hide();
		$("#mango-uploader-step-1").hide();            
      	$("#mango-uploader-step-2").hide();     
		$("#mango-uploader-step-3").hide();         
		$("#file-upload-show-btn").hide();    
 
      	picker.close();
       uploadedPrints = [];
       uploadedPrints2 = [];   
    }
  
    function uploadFinished(upfiles){
		  console.log(upfiles);
		$("#mango-printuploader-step-1").hide();            
      	$("#mango-printuploader-step-2").show();     
//		$("#mango-printuploader-step-3").hide();                 
      	//if(upfiles.lenght > 0) {

        $.each( upfiles, function( key, value ) {
            var temp_array = value.split('^');
            var filename = temp_array[0];              
            var handle = temp_array[1];            
            var filedata = "https://process.filestackapi.com/rotate=deg:exif/imagesize/"+handle;
          
            var thumb_width_px = 0;
            var thumb_height_px = 0;   
            var oryginal_width_px = 0;
            var oryginal_height_px = 0;
            var oryginal_ratio;             
            var ver2hor = 0;
          
            $.getJSON( filedata, function( data ) {
              //$("#mango-printuploader-printslist" ).append( '<div class="photo">'+data['height'] +'-'+ data['width'] + '|'+ ver2hor +'<div class="photo-img"><img src="https://cdn.filestackcontent.com/resize='+ rDim +'/crop=dim:['+ cDim +']/rotate=deg:270/' + handle + '" style="width:100%;" alt="" /></div><div class="photo-tools"><button class="btn-del">DEL</button><button class="btn-crop">CROP</button></div><div class="photo-qty"><span class="qty-dec">-</span><span class="qty-num">1</span><span class="qty-inc">+</span></div><input class="file_token" type="hidden" name="file_token" value="' + handle + '" /></div>' );  		
                oryginal_width_px = data['width'];
                oryginal_height_px = data['height'];
                oryginal_ratio = oryginal_height_px/oryginal_width_px; 

                if( oryginal_height_px > oryginal_width_px ) { 
                  ver2hor = 1;	
                  oryginal_ratio = oryginal_width_px/oryginal_height_px;  
                } else {
                  ver2hor = 0;	
                  oryginal_ratio = oryginal_height_px/oryginal_width_px;   
                }  
            var crop_x = 0;
            var crop_y = 0;   
            var crop_width = 0;
            var crop_height = 0;
              
                if( ver2hor == 1 ) {
                  thumb_width_px = Math.ceil(600 * prints_ratio);                   
                  thumb_height_px = 600;
                  if( oryginal_ratio < prints_ratio ) {  
                    crop_width = oryginal_width_px;
                    crop_height = Math.ceil(oryginal_width_px/prints_ratio);
                    crop_x = 0;
                    crop_y = Math.ceil( (oryginal_height_px-crop_height)/2 );                     
                    console.log('dla zdjecia pionowego szerszego niż odbitka');                    
                    //resize=width:thumb_width_px,height:thumb_height_px/
                    //$("#mango-printuploader-printslist" ).append( '<div class="photo"><div class="photo-img"><img src="https://cdn.filestackcontent.com/crop=dim:['+crop_x+','+crop_y+','+crop_width+','+crop_height+']/' + handle + '" style="width:100%;" alt="" /><input class="file_token" type="hidden" name="file_token" value="' + handle + '" /></div><div class="photo-tools"><button class="btn-del"><i class="fa-solid fa-trash-can"></i> Usuń zdjęcie</button></div>' );  		                    
                    $("#mango-printuploader-printslist" ).append( '<div class="photo"><div class="photo-img"><img src="https://cdn.filestackcontent.com/resize=width:'+thumb_width_px+',h:'+thumb_height_px+',fit:crop/' + handle + '" style="width:100%;max-height:100%;" alt="" /><input class="file_token" type="hidden" name="file_token" value="' + handle + '" /></div><div class="photo-tools"><button class="btn-del"><i class="fa-solid fa-trash-can"></i> Usuń zdjęcie</button></div>' );  		                                        
                  } else {
                    console.log('dla zdjecia pionowego wezszego niż odbitka');    
//                    $("#mango-printuploader-printslist" ).append( '<div class="photo"><div class="photo-img"><img src="https://cdn.filestackcontent.com/resize=width:'+thumb_width_px+'/crop=dim:[0,0,'+thumb_width_px+','+thumb_height_px+']/' + handle + '" style="width:100%;" alt="" /><input class="file_token" type="hidden" name="file_token" value="' + handle + '" /></div><div class="photo-tools"><button class="btn-del"><i class="fa-solid fa-trash-can"></i> Usuń zdjęcie</button></div>' );  		
                    $("#mango-printuploader-printslist" ).append( '<div class="photo"><div class="photo-img"><img src="https://cdn.filestackcontent.com/resize=width:'+thumb_width_px+',h:'+thumb_height_px+',fit:crop/' + handle + '" style="width:100%;max-height:100%;" alt="" /><input class="file_token" type="hidden" name="file_token" value="' + handle + '" /></div><div class="photo-tools"><button class="btn-del"><i class="fa-solid fa-trash-can"></i> Usuń zdjęcie</button></div>' );  		                                                            
                  }

                } else {
                  thumb_width_px = 600;
                  thumb_height_px = Math.ceil(600 * prints_ratio);     
                  
                  if( oryginal_ratio <= prints_ratio ) {  
                    crop_width = oryginal_width_px;
                    crop_height = Math.ceil(oryginal_width_px/prints_ratio);
                    crop_x = 0;
                    crop_y = Math.ceil( (oryginal_height_px-crop_height)/2 );                     
                    console.log('dla zdjecia poziomego szerszego niż odbitka');                    
                    //resize=width:thumb_width_px,height:thumb_height_px/
                    $("#mango-printuploader-printslist" ).append( '<div class="photo"><div class="photo-img"><img src="https://cdn.filestackcontent.com/resize=width:'+thumb_width_px+',h:'+thumb_height_px+',fit:crop/' + handle + '" style="width:100%;" alt="" /><input class="file_token" type="hidden" name="file_token" value="' + handle + '" /></div><div class="photo-tools"><button class="btn-del"><i class="fa-solid fa-trash-can"></i> Usuń zdjęcie</button></div>' );  		                    
                  } else {
                    console.log('dla zdjecia poziomego wezszego niż odbitka');    
                    $("#mango-printuploader-printslist" ).append( '<div class="photo"><div class="photo-img"><img src="https://cdn.filestackcontent.com/resize=width:'+thumb_width_px+',h:'+thumb_height_px+',fit:crop/' + handle + '" style="width:100%;" alt="" /><input class="file_token" type="hidden" name="file_token" value="' + handle + '" /></div><div class="photo-tools"><button class="btn-del"><i class="fa-solid fa-trash-can"></i> Usuń zdjęcie</button></div>' );  		
                  }                
//                  $("#mango-printuploader-printslist" ).append( '<div class="photo"><div class="photo-img"><img src="https://cdn.filestackcontent.com/resize=width:'+thumb_width_px+',h:'+thumb_height_px+',fit:crop/' + handle + '" style="width:100%;" alt="" /><input class="file_token" type="hidden" name="file_token" value="' + handle + '" /></div><div class="photo-tools"><button class="btn-del"><i class="fa-solid fa-trash-can"></i> Usuń zdjęcie</button></div>' );  		                  
                }
                console.log(thumb_width_px+'-'+thumb_height_px+','+prints_ratio+'vs'+oryginal_ratio+',,');



            });
            //countPrints();          
            $(".mango-uploader-status").show();
            $(".mango-uploader-prints-qty").html(upfiles.length);    
            $(".mango-uploader-prints-sum").html( calculatePrintsPrice( variants, pricelist, upfiles.length) );               
        });


      
      	//}
		// po dodaniu plików, pokazujemy panel z lista plików i znika button do dodawania zdjec      
    }




  

});
